<footer class="footer footer-style mat-elevation-z4" *ngIf="!isMobile">
    <div style="width: 76vw;
    display: flex;
    justify-content: space-between;
        padding-right: 2%;">
        <div style="display: flex;gap: 20px;">
            <span (click)="onOpenTermsPopup()" style="cursor: pointer;" matFab extended>Terms</span>
            <span> <a [href]="link.PrivacyPolicy" style="color: white;text-decoration: none;" target="_blank"
                    rel="noopener noreferrer">
                    Privacy Policy
                </a> </span>
        </div>
        <div style="width: 15vw;
    display: flex;
    justify-content: end;
    gap: 20px;">
            <span> <a [href]="link.Navigator" style="color: white;text-decoration: none;" target="_blank"
                    rel="noopener noreferrer">
                    Navigator
                </a> </span>
            <span>
                <a [href]="link.CPSwag" target="_blank" style="color: white;text-decoration: none;"
                    rel="noopener noreferrer">
                    CP Swag
                </a></span>
        </div>
    </div>
</footer>